import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { SKIP_ALL_ERROR_NOTIFICATIONS } from '../../../core/interceptors/skip-error-notification.token';
import { APP_CONFIG } from '../../../core/tokens/app-config.token';
import { NotificacionDto } from '../../domain/notifications/notification.dto';

@Injectable({ providedIn: 'root' })
export class NotificationsApi {
  private readonly http = inject(HttpClient);
  private readonly config = inject(APP_CONFIG);

  list(): Observable<NotificacionDto[]> {
    return this.http.get<NotificacionDto[]>(`${this.config.apiUrl}/notificaciones`, {
      context: new HttpContext().set(SKIP_ALL_ERROR_NOTIFICATIONS, true),
    });
  }

  unreadCount(): Observable<{ noLeidas: number }> {
    return this.http.get<{ noLeidas: number }>(`${this.config.apiUrl}/notificaciones/contador`, {
      context: new HttpContext().set(SKIP_ALL_ERROR_NOTIFICATIONS, true),
    });
  }

  markRead(id: string): Observable<void> {
    return this.http.patch<void>(`${this.config.apiUrl}/notificaciones/${id}/leida`, {});
  }
}
